import React from 'react';
import { AUTH_CODE_LABEL } from 'common/constants/login';
import { AuthenticationInputProps } from './AuthenticationInput.props';
import { StyledHelperText, StyledTextField } from './AuthenticationInput.styles';

const AuthenticationInput = ({ formState, handleChange }: AuthenticationInputProps) => {
  const { values, errors } = formState;
  const error = Boolean(errors?.otp?.[0]);
  const helperText = errors?.otp?.[0] ?? null;

  return (
    <StyledTextField
      id="enter-user-otp"
      className="scar-textField"
      variant="standard"
      name="otp"
      value={values.otp || ''}
      label={AUTH_CODE_LABEL}
      fullWidth
      type="text"
      error={error}
      required
      helperText={helperText && <StyledHelperText>{helperText}</StyledHelperText>}
      onChange={handleChange}
    />
  );
};

export default AuthenticationInput;
